import {
    Component,
    OnInit
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { PrimeTemplate } from 'primeng/api';
import { Toast } from 'primeng/toast';

import { AuthService } from '@/auth/services';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterModule, Toast, PrimeTemplate],
    template: `
        <router-outlet></router-outlet>
        <p-toast [showTransitionOptions]="'250ms'" [showTransformOptions]="'translateX(100%)'" [hideTransitionOptions]="'150ms'" [hideTransformOptions]="'translateX(100%)'">
            <ng-template let-message pTemplate="message">
                <span class="p-toast-message-icon text-2xl">
                    <i class="pi pi-exclamation-triangle"></i>
                </span>
                <div class="flex flex-column gap-3 w-full">
                    <div class="p-toast-message-text">
                        <div class="p-toast-summary">{{ message.summary }}</div>
                        <div class="p-toast-detail" [innerHTML]="message.detail"></div>
                    </div>
                </div>
            </ng-template>
        </p-toast>
    `
})
export class AppComponent implements OnInit {
    constructor(
        private authService: AuthService
    ) {
    }

    ngOnInit() {
        if (this.authService.user) {
            this.authService.me().subscribe({
                next: () => {
                },
                error: () => {
                    this.authService.logout('session-invalid');
                }
            });
        } else {
            const token = this.authService.getToken();
            if (token) {
                this.authService.me().subscribe({
                    error: () => this.authService.logout('unauthorized')
                });
            }
        }
    }
}
